import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAssetViewerState } from '@hooks/useAssetViewerState';
import { UXP_SYNC_PREMIERE_PLAYHEAD } from '@helpers/uxpEmbeddedMediaViewer';

export function UxpPremierePlayheadSync() {
  const { assetId } = useParams();
  const { selectedCommentId, commentsList } = useAssetViewerState();

  useEffect(() => {
    const { uxpHost } = window as unknown as {
      uxpHost?: { postMessage: (msg: object) => void };
    };
    if (!uxpHost || !assetId) return;
    if (
      !selectedCommentId ||
      selectedCommentId === 'new' ||
      selectedCommentId === 'reply'
    ) {
      return;
    }

    const comment = commentsList.find((c) => c.id === selectedCommentId);
    const raw = comment?.timeCode?.fromSeconds;
    if (raw == null || !Number.isFinite(raw)) return;

    uxpHost.postMessage({
      type: UXP_SYNC_PREMIERE_PLAYHEAD,
      assetId,
      seconds: Math.max(0, raw)
    });
  }, [assetId, selectedCommentId, commentsList]);

  return null;
}
